<template>
  <nav
    class="navbar navbar-main navbar-expand-lg shadow-none"
    :class="
      this.$store.state.isRTL ? 'top-0 position-sticky z-index-sticky' : ''
    "
    v-bind="$attrs"
    id="navbarBlur"
    data-scroll="true"
  >
    <div class="px-3 py-1 container-fluid d-flex align-items-center">
      <button
        class="navbar-toggler-bars me-3"
        type="button"
        aria-label="Toggle menu"
        @click="toggleSidebar"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <breadcrumbs :currentPage="currentRouteName" textWhite="text-dark" />

      <div
        class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="this.$store.state.isRTL ? 'px-0' : 'me-sm-4'"
        id="navbar"
      >
        <div
          class="pe-md-3 d-flex align-items-center"
          :class="this.$store.state.isRTL ? 'me-md-auto' : 'ms-md-auto'"
        >
          <div class="input-group">
            <span class="input-group-text text-body">
              <i class="fas fa-search" aria-hidden="true"></i>
            </span>
            <input
              type="text"
              class="form-control"
              :placeholder="
                this.$store.state.isRTL ? 'أكتب هنا...' : 'Type here...'
              "
            />
          </div>
        </div>
        <ul class="navbar-nav justify-content-end">
          <li class="nav-item d-flex align-items-center">
            <a @click="logout" class="text-dark nav-link" href="#">
              <i
                class="fa fa-user"
                :class="this.$store.state.isRTL ? 'ms-sm-2' : 'me-sm-2'"
              ></i>
              <span class="d-sm-inline d-none">Logout</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import Breadcrumbs from "../Breadcrumbs.vue";
import { mapMutations } from "vuex";

export default {
  inheritAttrs: false,
  name: "navbarComponent",
  data() {
    return {
      showMenu: false,
    };
  },
  props: ["textWhite"],
  methods: {
    ...mapMutations(["toggleSidebarCollapse", "toggleConfigurator"]),

    toggleSidebar() {
      if (window.innerWidth >= 992) {
        this.toggleSidebarCollapse();
      } else {
        document.getElementById("app")?.classList.toggle("sidenav-mobile-open");
      }
    },

    logout() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/signin");
    },
  },
  components: {
    Breadcrumbs,
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
};
</script>
